import React from 'react';
import { Box, Avatar, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { capitalizeFirstLetter } from '../utils/lib';
import PropTypes from 'prop-types';
import InventoryIcon from '@mui/icons-material/Inventory';
import PetIcon from '@mui/icons-material/Pets';
import { useTranslation } from 'react-i18next';

const ListItemSupplyRemove = ({
  pet,           // Objeto mascota
  product,       // Objeto producto
  dateTentative, // Fecha tentativa (Date object)
  info,          // Información adicional
  onDelete,      // Función para eliminar la fila
  index,
}) => {
  const { t, i18n } = useTranslation();

  const avatar = pet.thumb_url ? (
    <Avatar
      alt={capitalizeFirstLetter(pet.name)}
      src={pet.thumb_url}
      sx={{ width: 30, height: 30 }}
    />
  ) : (
    <Avatar sx={{ width: 30, height: 30 }}>
      {/* <InventoryIcon sx={{ fontSize: 16 }} /> */}
      <PetIcon sx={{ fontSize: 16 }} />
    </Avatar>
  );

  // Formatear fecha
  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString(i18n.language, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <Box
      display="flex"
      alignItems="flex-start"
      width="100%"
      sx={{ 
        paddingX: '8px',
        paddingY: '4px'
      }}
    >
      {/* Imagen del producto */}
      {avatar}

      {/* Contenedor central para los textos */}
      <Box
        display="flex"
        flexDirection="column"
        flexGrow={1}
        ml={1}
        mr={1}
      >
        {/* Línea 1: Nombre de la mascota */}
        <Typography
          variant="subtitle2"
          sx={{ 
            fontWeight: 'normal',
            marginBottom: '2px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {pet?.name || ''}
        </Typography>

        {/* Línea 2: Nombre del producto */}
        <Typography
          variant="body2"
          sx={{ 
            marginBottom: '2px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {product?.name || ''}
        </Typography>

        {/* Línea 3: Fecha tentativa */}
        <Typography
          variant="body2"
          sx={{ 
            marginBottom: '2px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {t('layouts.toSupply')} {formatDate(dateTentative)}
        </Typography>

        {/* Línea 4: Información adicional */}
        {info && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ 
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {info}
          </Typography>
        )}
      </Box>

      {/* Botón para eliminar el item */}
      {onDelete && (
        <IconButton 
          onClick={() => onDelete(index)} 
          sx={{ 
            width: '42px', 
            height: '42px',
            alignSelf: 'center'
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

ListItemSupplyRemove.propTypes = {
  pet: PropTypes.object,
  product: PropTypes.object,
  dateTentative: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  info: PropTypes.string,
  onDelete: PropTypes.func,
  index: PropTypes.number,
};

export default ListItemSupplyRemove; 